import { ReactNode } from 'react'
import RequireAccess from './index'

interface IProps {
  children: ReactNode
}

/** Solicitudes internas (workflows /administration): solo admin LMS. */
export const RequireInternalRequestsAccess = ({ children }: IProps) => {
  return (
    <RequireAccess allow={({ isAdmin }) => isAdmin()} fallbackPath="/forbidden">
      {children}
    </RequireAccess>
  )
}

export default RequireInternalRequestsAccess
